// Produktseite: Galerie, Menge, Variantenwahl. Ohne Bibliothek, nativer Scroll.
(function () {
  var root = document.querySelector('[data-product]');
  if (!root) return;

  // ----- Galerie -----
  var main = root.querySelector('#dn-main-image');
  root.querySelectorAll('.dn-thumb').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!main) return;
      main.src = btn.dataset.src;
      main.removeAttribute('srcset');
      root.querySelectorAll('.dn-thumb').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });

  // ----- Menge -----
  var qtyInput = root.querySelector('.dn-qty input');
  root.querySelectorAll('[data-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      var next = parseInt(qtyInput.value, 10) + parseInt(b.dataset.qty, 10);
      qtyInput.value = Math.max(1, isNaN(next) ? 1 : next);
    });
  });

  // ----- Varianten -----
  var raw = root.querySelector('[data-variants]');
  if (!raw) return;
  var variants;
  try { variants = JSON.parse(raw.textContent); } catch (e) { return; }

  var form = root.querySelector('[data-product-form]');
  var idField = root.querySelector('[data-variant-id]');
  var priceNow = root.querySelector('[data-price-current]');
  var priceOld = root.querySelector('[data-price-compare]');
  var addBtn = root.querySelector('[data-add]');
  var stock = root.querySelector('[data-stock]');
  var priceWrap = root.querySelector('[data-price]');

  function money(cents) {
    // Shop rechnet in CHF; Format bewusst gleich wie serverseitig gerendert.
    return 'CHF ' + (cents / 100).toFixed(2);
  }

  function selected() {
    return Array.from(root.querySelectorAll('[data-option]:checked')).map(function (i) { return i.value; });
  }

  function match(opts) {
    return variants.find(function (v) {
      return opts.every(function (val, i) { return v.options[i] === val; });
    });
  }

  function update() {
    var opts = selected();
    if (!opts.length) return;
    var v = match(opts);

    if (!v) {
      addBtn.disabled = true;
      addBtn.textContent = 'Nicht verfügbar';
      if (stock) stock.innerHTML = '<span class="dn-dot"></span>Diese Kombination gibt es nicht';
      return;
    }

    idField.value = v.id;
    priceNow.textContent = money(v.price);

    var onSale = v.compare_at_price && v.compare_at_price > v.price;
    priceWrap.classList.toggle('dn-card__price--sale', !!onSale);
    if (onSale) {
      if (!priceOld) {
        priceOld = document.createElement('s');
        priceOld.setAttribute('data-price-compare', '');
        priceWrap.appendChild(priceOld);
      }
      priceOld.textContent = money(v.compare_at_price);
      priceOld.hidden = false;
    } else if (priceOld) {
      priceOld.hidden = true;
    }

    addBtn.disabled = !v.available;
    addBtn.textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft';
    if (stock) {
      stock.innerHTML = v.available
        ? '<span class="dn-dot dn-dot--ok"></span>An Lager'
        : '<span class="dn-dot"></span>Zurzeit nicht verfügbar';
    }

    // Adresse mitziehen, damit ein geteilter Link dieselbe Variante zeigt
    if (history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url);
    }

    var img = v.featured_image && v.featured_image.src;
    if (img && main) { main.src = img; main.removeAttribute('srcset'); }
  }

  root.querySelectorAll('[data-option]').forEach(function (i) {
    i.addEventListener('change', update);
  });
  if (form) update();
})();
